module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"createFxRateButton.errorMessage":"There was an error encountered while creating this fx rate. If everything looks right please contact support so we can help you :)"}}')
  delete Component.options._Ctor
}
